import { vModelText as _vModelText, withKeys as _withKeys, createElementVNode as _createElementVNode, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, vShow as _vShow, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass, Transition as _Transition } from "vue"

const _hoisted_1 = { class: "input-group" }
const _hoisted_2 = ["id", "placeholder"]
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "input-group-append search-input-magnifying-glass-append" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi-search" })
], -1)
const _hoisted_4 = { key: 0 }
const _hoisted_5 = {
  key: 1,
  class: "p-3"
}
const _hoisted_6 = {
  key: 0,
  class: "fake-option heading d-flex align-items-center"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "akatemia-icon",
    src: "/Akatemia_hankkeet.png"
  })
], -1)
const _hoisted_8 = ["aria-label", "aria-selected"]
const _hoisted_9 = {
  key: 0,
  class: "text-container flex-fill"
}
const _hoisted_10 = {
  key: 0,
  class: "search-badges-container"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_bs_icon = _resolveComponent("bs-icon")!
  const _component_spinner = _resolveComponent("spinner")!
  const _component_HighlightText = _resolveComponent("HighlightText")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_TagBadge = _resolveComponent("TagBadge")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["hako-multiselect", { 'menu-is-open': _ctx.showMenu }]),
    ref: "root",
    role: "listbox",
    "aria-multiselectable": "true"
  }, [
    _createElementVNode("div", _hoisted_1, [
      _withDirectives(_createElementVNode("input", {
        type: "text",
        class: "form-control",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.search) = $event)),
        id: _ctx.id,
        ref: "searchInput",
        onFocus: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showMenu = true)),
        onInput: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showMenu = true)),
        onKeydown: [
          _cache[3] || (_cache[3] = _withKeys(($event: any) => {_ctx.selectHoverOption(); _ctx.search = '';}, ["enter"])),
          _cache[4] || (_cache[4] = _withKeys(($event: any) => (_ctx.hoverNextOrPrevOption(+1)), ["down"])),
          _cache[5] || (_cache[5] = _withKeys(($event: any) => (_ctx.hoverNextOrPrevOption(-1)), ["up"]))
        ],
        placeholder: _ctx.placeholder
      }, null, 40, _hoisted_2), [
        [_vModelText, _ctx.search]
      ]),
      _hoisted_3
    ]),
    _withDirectives(_createElementVNode("div", {
      class: "dropdown-icon",
      onMousedown: _cache[6] || (_cache[6] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.clickDropdownIcon && _ctx.clickDropdownIcon(...args)), ["prevent"]))
    }, [
      _createVNode(_component_bs_icon, { icon: "chevron-down" })
    ], 544), [
      [_vShow, !_ctx.hideArrowInternal]
    ]),
    _createVNode(_Transition, { name: "menu" }, {
      default: _withCtx(() => [
        (_ctx.showMenu && !(_ctx.useAjax && _ctx.search.length < 2))
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass(["fake-select-menu", _ctx.options.length == 0 ? 'empty-select-menu' : 'results-found-select-menu'])
            }, [
              (_ctx.isLoading)
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                    _createVNode(_component_spinner, {
                      size: 2,
                      style: {"margin":"1rem"}
                    })
                  ]))
                : (_ctx.options.length == 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_5, " Ei tuloksia "))
                  : (!_ctx.isLoading && _ctx.options.length > 0)
                    ? (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(Object.keys(_ctx.optionsGrouped), (groupName) => {
                        return (_openBlock(), _createElementBlock(_Fragment, { key: groupName }, [
                          (groupName != 'undefined')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                                _createElementVNode("h3", null, _toDisplayString(groupName), 1)
                              ]))
                            : _createCommentVNode("", true),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.optionsGrouped[groupName], (option) => {
                            return (_openBlock(), _createElementBlock("div", {
                              class: "search-found-article",
                              key: option.value
                            }, [
                              _hoisted_7,
                              _createElementVNode("div", null, [
                                _createElementVNode("div", {
                                  class: "search-title-match-row",
                                  role: "option",
                                  "aria-label": option.text,
                                  "aria-selected": _ctx.ariaOptionIsSelected(option)
                                }, [
                                  ((option.categoryRoot || false) == false)
                                    ? (_openBlock(), _createElementBlock("label", _hoisted_9, _toDisplayString(option.category) + " > ", 1))
                                    : _createCommentVNode("", true),
                                  _createVNode(_component_router_link, {
                                    onClick: ($event: any) => (_ctx.selectOption(option)),
                                    to: '/artikkeli/'+option.value
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_HighlightText, {
                                        highlight: _ctx.search,
                                        content: option.name || ''
                                      }, null, 8, ["highlight", "content"])
                                    ]),
                                    _: 2
                                  }, 1032, ["onClick", "to"])
                                ], 8, _hoisted_8),
                                (option.tags && option.tags?.length>0)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sortTags(option.tags), (tag) => {
                                        return (_openBlock(), _createBlock(_component_TagBadge, {
                                          key: tag,
                                          onClick: ($event: any) => (_ctx.searchByTag(tag))
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_HighlightText, {
                                              highlight: _ctx.search,
                                              content: tag
                                            }, null, 8, ["highlight", "content"])
                                          ]),
                                          _: 2
                                        }, 1032, ["onClick"]))
                                      }), 128))
                                    ]))
                                  : _createCommentVNode("", true)
                              ])
                            ]))
                          }), 128))
                        ], 64))
                      }), 128))
                    : _createCommentVNode("", true)
            ], 2))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    (_ctx.showMenu)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "hako-multiselect-menu-closer",
          onClick: _cache[7] || (_cache[7] = _withModifiers(($event: any) => {_ctx.showMenu = false;}, ["prevent"]))
        }))
      : _createCommentVNode("", true)
  ], 2))
}